import { useReducer, useState } from 'react';

import { useDisplayedNotifications } from '@/hooks/useDisplayedNotifications';
import { useNotificationsFilters } from '@/hooks/useNotificationsFilters';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

import { NotificationBell } from './NotificationComponents/NotificationBell';
import { NotificationPanel } from './NotificationComponents/NotificationPanel';

const NotificationCenter = () => {
  const { filteredNotifications, isLoading } = useNotificationsFilters();
  const { isNotificationRead, markNotificationAsRead } = useDisplayedNotifications();
  // isNotificationRead reads sessionStorage directly (no reactive state) — bump this to force
  // a re-render once notifications are marked read, so the bell's dot updates in turn.
  const [, rerenderOnNotificationsRead] = useReducer((count: number) => count + 1, 0);

  const [isNotificationPanelOpen, setIsNotificationPanelOpen] = useState(false);

  const isUnread = filteredNotifications.some((notification) => !isNotificationRead(notification.id));

  const openNotificationPanel = () => {
    void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'notifications',
      event_detail_1: 'alerte_on',
    });
    // Opening the panel is how a user "reads" their notifications — mark them all read at once.
    filteredNotifications.forEach((notification) => markNotificationAsRead(notification.id));
    rerenderOnNotificationsRead();
    setIsNotificationPanelOpen(true);
  };

  const closeNotificationPanel = () => {
    void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'notifications',
      event_detail_1: 'alerte_off',
    });
    setIsNotificationPanelOpen(false);
  };

  return (
    <>
      <NotificationBell onClick={openNotificationPanel} isUnread={isUnread} />

      <NotificationPanel
        isOpen={isNotificationPanelOpen}
        onCloseClick={closeNotificationPanel}
        onNativeClose={() => setIsNotificationPanelOpen(false)}
        notifications={filteredNotifications}
        isLoading={isLoading}
      />
    </>
  );
};

export { NotificationCenter };
